
import { Component, Prop, VModel, mixins } from 'nuxt-property-decorator'
import AuthMixin from '~/utils/mixins/authMixin'
import { BaseMintedCollection as MintedCollection } from './types'
import { NeoField, NeoSelect } from '@kodadot1/brick'

@Component({
  components: {
    NeoField,
    NeoSelect,
  },
})
export default class CollectionSelect extends mixins(AuthMixin) {
  @VModel({ default: null }) selectedCollection!: MintedCollection
  @Prop({ type: Array, default: () => [] }) collections!: MintedCollection[]
  @Prop({ type: Boolean, default: false }) showExplainerText!: boolean
}
